import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useIdentityList = (filters, options) => {
  return useQueryWithLogout([QueryKeys.IDENTITY_LIST, filters], async () => {
      const { data } = await getRequest({
        url: apiRoutes.RECIPIENT,
        params: filters,
      });

      return data;
    },
    options,
  );
};
